import { AccountWithExtraInfo, Currency } from '@orbis-systems/orbis-api-middleware';
import { QueryClient } from '@tanstack/react-query';

import { combineAccountsWithRtbs, formatPortfolio, getPortfolioSecurityTotalValue } from '../branch/adapters';
import { combinePositions } from '../branch/combinePositions';
import { branchQueries } from '../branch/queries';
import { userQueries } from './queries';

export const buildAccountPortfolioWithBreakdownFromCache =
    ({ currency = Currency.UsDollar, accountId }: { currency?: string; accountId: number }) =>
    ({ client }: { client: QueryClient }) => {
        const branchPortfolio = client.getQueryData(
            branchQueries.branchPortfolio({ currency, combined: false }).queryKey,
        )?.data;
        const branchRtbs = client.getQueryData(branchQueries.branchRtbs().queryKey)?.data;
        const userData = client.getQueryData(userQueries.userInformation().queryKey)?.data;

        if (branchPortfolio && branchRtbs && userData?.accountList) {
            client.removeQueries({
                type: 'inactive',
                queryKey: [...userQueries.all().queryKey, 'accountPortfolioWithBreakdownFromBranch', accountId],
            });
            const { entries, ...restPortfolio } = branchPortfolio;
            const selectedAccounts = userData.accountList.filter((account) => account.accountId === accountId);
            const selectedRtbs = branchRtbs.filter((item) => item.accountId === accountId);
            const accountPortfolioUncombined = entries.filter((item) => item.accountId === accountId);
            const accountsWithRtbs = combineAccountsWithRtbs(selectedAccounts, selectedRtbs);
            const accountPortfolioCombined = combinePositions(accountPortfolioUncombined);
            const modelSecurityTotalValue = getPortfolioSecurityTotalValue(accountPortfolioCombined);
            const accountPortfolioWithCombinedPositions = {
                ...restPortfolio,
                entries: accountPortfolioCombined,
                currency,
                modelSecurityTotalValue,
            };
            const portfolio = formatPortfolio(
                accountPortfolioWithCombinedPositions,
                accountsWithRtbs,
                [],
                modelSecurityTotalValue,
            );
            const account: AccountWithExtraInfo | undefined = accountsWithRtbs[0];
            return { portfolio, account };
        } else throw new Error('accountPortfolioWithBreakdownFromBranch: expected source queries populated');
    };
